import * as React from 'react';
import { GraduationHat02 } from '@untitled-ui/icons-react';
import { withAngularIntegration } from '../../common/componentUtils/reactComponentRegistration';

export const GraduationHatIcon: React.FunctionComponent = () => <GraduationHat02 />;
GraduationHatIcon.displayName = 'GraduationHatIcon';
export const GraduationHatIconAngular = withAngularIntegration(GraduationHatIcon, 'graduationHatIcon', {});
